import type { FPlusLiteralType } from '@festina-life/fplus-monaco'

export const initialEmptyLiteralValue: Record<FPlusLiteralType, string> = {
  string: '""',
  boolean: 'false',
  enum: '',
  fraction: '0%',
  integer: '0',
  null: '',
  blank: '',
}
